<template>
  <section
    class="otcDeatilOrder-chat main-bg"
    :style="{ height: `${chatHeight}px`, top: `${chatTop - 1}px` }"
    v-if="isReady"
  >
    <ul
      class="chat-title a-2-bd"
      v-if="status === '5' && commonData.isComplainUser.toString() === '1'"
    >
      <li :class="tab === 'server' ? 'b-2-cl' : ''" @click="setTab('server')">
        <!-- 客服 -->
        {{ $t("otcDetailOrder.chatServer") }}
        <span class="a-12-bg" v-if="tab === 'server'"></span>
      </li>
      <li :class="tab === 'user' ? 'b-2-cl' : ''" @click="setTab('user')">
        <!-- 商家 -->
        {{ $t("otcDetailOrder.chatUser") }}
        <span class="a-12-bg" v-if="tab === 'user'"></span>
      </li>
    </ul>
    <div class="chat-content">
      <!-- 客服 -->
      <div class="chat-server" v-show="tab === 'server'">
        <div :style="{ height: `${chatServerHeight}px` }" class="chat-server-message">
          <vue-scroll ref="serverMessage">
            <ul ref="serverList">
              <!-- 系统消息：您已成功提交申诉，请耐心等待。 -->
              <li class="chat-server-first">
                {{ $t("otcDetailOrder.chatServerMessage") }}
              </li>
              <li
                v-for="(item, index) in serverData"
                :key="index"
                :class="item.userType.toString() === '2' ? 'chat-right' : 'chat-left'"
                class="chat-item clearfix"
              >
                <div
                  class="chat-page"
                  :class="item.userType.toString() === '2' ? 'chat-right a-12-bg' : 'chat-left'"
                >
                  <!-- {{item}} -->
                  <div v-if="item.userType.toString() === '1'">
                    <svg class="icon icon-30" aria-hidden="true">
                      <use xlink:href="#icon-h_2"></use>
                    </svg>
                  </div>
                  <div v-else>
                    <img v-if="serverMy.imageUrl.length" :src="serverMy.imageUrl" />
                    <span class="b-2-cl" v-else>{{ serverMy.otcNickName[0] }}</span>
                  </div>
                  <!-- {{item.userType.toString() === '2' ? 'chat-right' : 'chat-left'}} -->
                </div>
                <div class="chat-message">
                  <!-- 文字 -->
                  <div class="clearfix">
                    <div
                      class="chat-message-text"
                      :class="item.userType.toString() === '2' ? 'a-12-bg b-8-cl' : 'a-2-bg b-1-cl'"
                      v-if="item.contentType.toString() === '1'"
                    >
                      {{ item.replayContent }}
                    </div>
                    <!-- 图片 -->
                    <div class="chat-message-img a-2-bg" v-if="item.contentType.toString() === '2'">
                      <img :src="item.replayContent" />
                    </div>
                    <!-- 视频 -->
                    <div class="chat-message-video a-2-bg" v-if="item.contentType.toString() === '3'">
                      <video :src="item.replayContent" controls :poster="item.replayContent" ref="messageVideo"></video>
                      <div class="chat-message-video-icons">
                        <a-spin v-if="!!item.loading" :spinning="!!item.loading" size="small"/>
                        <template v-else>
                          <svg-icon v-if="item.error" iconClass="warningIcon" className="icon-18" @click="retryVideo(index)"></svg-icon>
                          <svg-icon v-else iconClass="tip-success" className="icon-18"></svg-icon>
                        </template>
                      </div>
                    </div>
                  </div>
                  <div class="chat-message-time" v-if="item.ctime">{{ item.ctime | setTime }}</div>
                </div>
              </li>
            </ul>
          </vue-scroll>
        </div>
        <div class="chat-send a-2-bg">
          <input
            class="b-1-cl textInput"
            @keyup="serverInpKeyup"
            maxlength="50"
            :placeholder="$t('otcDetailOrder.chatServerInp')"
            v-model="serverInp"
          />
          <div class="sendButton">
            <div class="sendButton-img">
              <span class="sendButton-bg">
                <svg-icon iconClass="icon-image" className="icon-16"></svg-icon>
              </span>
              <input
                type="file"
                class="files"
                @change="fileChange"
                accept="image/gif, image/jpeg, image/jpg, image/png"
                name="file"
                ref="fileInp"
              />
            </div>
            <div class="sendButton-img">
              <span class="sendButton-bg">
                <svg-icon iconClass="icon-video" className="icon-16"></svg-icon>
              </span>
              <input
                type="file"
                class="files"
                @change="getvideo($event)"
                accept="video/mp4, video/avi, video/hevc, video/mpeg, .wmv, .mov, .flv, .mkv, .ts"
                name="file"
                ref="videoInp"
              />
            </div>
            <c-button
              height="30px"
              class="buttonClass"
              :disabled="serverBtnDisabled"
              :loading="serverBtnLoading"
              name="serverButton"
              @click="serverBtnClick"
              >{{ $t("otcDetailOrder.chatServerBut") }}</c-button
            >
          </div>
        </div>
      </div>
      <!-- 商家 -->
      <div class="chat-user" v-show="tab === 'user'">
        <div class="chat-user-title a-2-bg">
          <div class="a-12-bg user-page" @click="goUid(userMess.uid)">
            <img v-if="userMess.imageUrl.length" :src="userMess.imageUrl" />
            <span class="b-8-cl" v-else>{{ userMess.otcNickName[0] }}</span>
          </div>
          <div class="user-mess">
            <div class="user-name b-2-cl">
              {{ userMess.otcNickName }}
              <span v-html="userVip" style="margin-left: 6px"></span>
            </div>
            <div class="user-status">
              {{
                userMess.isOnline.toString() === "1"
                  ? $t("otcDetailOrder.inline")
                  : $t("otcDetailOrder.outline")
              }}
            </div>
          </div>
          <div class="user-text">
            <div class="user-name b-2-cl">{{ userMess.completeOrders }}</div>
            <!-- 成交量 -->
            <div class="user-status">{{ $t("otcDetailOrder.chatVolume") }}</div>
          </div>
        </div>
        <div class="chat-user-message" :style="{ height: `${chatUserHeight}px` }">
          <vue-scroll ref="userMessage" :opt="userScrollOpt">
            <ul ref="userList">
              <!-- <li class="chat-server-first">系统消息：您已成功提交申诉，请耐心等待。</li> -->
              <li
                v-for="(item, index) in userData"
                :key="index"
                :class="item.userType.toString() === '2' ? 'chat-right' : 'chat-left'"
                class="chat-item clearfix"
              >
                <div class="chat-page a-12-bg">
                  <img v-if="item.obj.imageUrl.length" :src="item.obj.imageUrl" />
                  <span class="b-8-cl" v-else>{{ item.obj.otcNickName[0] }}</span>
                </div>
                <div class="chat-message">
                  <!-- 文字 -->
                  <div class="clearfix">
                    <div
                      class="chat-message-text"
                      :class="item.userType.toString() === '2' ? 'a-12-bg b-8-cl' : 'a-2-bg b-1-cl'"
                      v-if="item.contentType.toString() === '1'"
                    >
                      {{ item.replayContent }}
                    </div>
                    <!-- 图片 -->
                    <div class="chat-message-img a-2-bg" v-if="item.contentType.toString() === '2'">
                      <img :src="item.replayContent" />
                    </div>
                  </div>
                  <div class="chat-message-time">{{ item.ctime | setTime }}</div>
                </div>
              </li>
            </ul>
          </vue-scroll>
        </div>
        <div class="chat-send a-2-bg">
          <input
            class="b-1-cl textInput"
            @keyup="userInpKeyup"
            maxlength="50"
            ref="userInput"
            :placeholder="$t('otcDetailOrder.chatUserInp')"
            v-model="userInp"
          />
          <div class="sendButton">
            <c-button
              height="30px"
              class="buttonClass"
              name="userButton"
              :disabled="userBtnDisabled"
              :loading="userBtnLoading"
              @click="userBtnClick"
            >
              {{ $t("otcDetailOrder.chatUserBut") }}
            </c-button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import moment from 'moment';
import { timeFn, getChatWsUrl } from '@/utils';

export default {
  data() {
    return {
      userScrollOpt: {
        detectResize: true,
        scrollPanel: {
          initialScrollY: 999999,
          initialScrollX: false,
          scrollingX: true,
          scrollingY: true,
          speed: 300,
          easing: undefined,
          verticalNativeBarPos: 'right',
        },
      },
      tab: '', // server客服 user商家
      serverData: [],
      serverInp: '',
      serverBtnLoading: false,
      serverTimer: null,
      serverScroll: false,
      userBtnLoading: false,
      userWs: null,
      userWsReady: false, //
      userData: [], // 商户数据
      userInp: '', // 商户框
      chatId: '', // ws信息
      userTime: null, // 发送ws消息的time 用于loding的过程
      wsTime: null, // 用于重新连接ws
      sendTimer: null, // 商家聊天 若五秒没从服务端返
      resetTimer: null, // 商家聊天 若在三秒内重复创建
      chatHeight: 684,
      userTimes: null, // 发送消息倒计时
      video: "",
      videoLoading: false,
      videoError: false,
      videoEvent: [],
    };
  },
  props: {
    // 1-5 为正常流程  6是服务端状态  7为异常订单 8按3处理(客服介入强制使订单完成)
    // 待支付1 已支付2 交易成功3 取消 4 申诉 5 打币中6 异常订单7 申诉处理结束8
    commonData: { default: () => ({}), type: Object },
    // 当前订单 是买数字货币BUY 还是卖数字货币SELL
    isReady: { default: false, type: Boolean },
    chatTop: { default: 0, type: Number },
  },
  filters: {
    setTime(v) {
      return timeFn(new Date(Number(v)), 'yyyy-MM-dd hh:mm:ss');
    },
  },
  watch: {
    status(v) {
      if (v === '5' && this.commonData.isComplainUser.toString() === '1') {
        this.tab = 'server';
      } else {
        this.tab = 'user';
      }
    },
    tab(v) {
      if (v === 'server') {
        // 清除 商家聊天 若五秒没从服务端返回相同数据的后续操作
        if (this.sendTimer) {
          clearTimeout(this.sendTimer);
        }
        // 清除 商家聊天 若在三秒内重复创建ws的后续操作
        if (this.resetTimer) {
          clearTimeout(this.resetTimer);
        }
        // 如果 商家聊天 ws已经创建好了，则给他断开
        if (this.userWsReady) {
          this.userWs.close();
        }
        // 获取 客服聊天数据
        this.getServerData();
        this.serverScroll = true;
      } else if (v === 'user') {
        // 清除 循环请求客服聊天数据
        if (this.serverTimer) {
          clearInterval(this.serverTimer);
        }
        // 创建ws并且请求历史数据
        this.initUser();
      }
    },
    otcWsUrl(otcWsUrl) {
      if (otcWsUrl) {
        this.initUser();
      }
    },
  },
  computed: {
    /**
     * 商户状态，0:未认证，1：普通商户，2：超级商户，3：等待释放
     */
    userVip() {
      let str = '';
      // if (this.userInfo && this.userInfo.otcCompanyInfo) {
      //   if (Number(this.userInfo.otcCompanyInfo.status)) {
      if (this.userMess.companyLevel === 1) {
        str = `<svg class="icon icon-16" aria-hidden="true">
              <use xlink:href="#icon-c_16"></use>
            </svg>`;
      } else if (this.userMess.companyLevel === 2) {
        str = `<svg class="icon icon-16" aria-hidden="true">
              <use xlink:href="#icon-c_17"></use>
            </svg>`;
      }
      // }
      // }
      return str;
    },
    userInfo() {
      return this.$store.state.baseData.userInfo;
    },
    serverMy() {
      let obj = {};
      if (this.commonData.side === 'BUY') {
        obj = this.commonData.buyer;
      } else {
        obj = this.commonData.seller;
      }
      return obj;
    },
    userMess() {
      let obj = {};
      if (this.commonData.side === 'BUY') {
        obj = this.commonData.seller;
      } else if (this.commonData.side === 'SELL') {
        obj = this.commonData.buyer;
      }
      return obj;
    },
    otcWsUrl() {
      let str = '';
      if (this.$store.state.baseData.otcPublicInfo) {
        str = this.$store.state.baseData.otcPublicInfo.otcChatWS;
      }
      return str;
      // return 'wss://ws2.chaindown.com/otc-chat/chatServer'
    },
    serverBtnDisabled() {
      let flag = true;
      if (this.serverInp.length || this.serverBtnLoading) {
        flag = false;
      }
      return flag;
    },
    userBtnDisabled() {
      let flag = true;
      if (this.userInp.length || this.userBtnLoading) {
        flag = false;
      }
      return flag;
    },
    status() {
      if (this.commonData.status) {
        return this.commonData.status.toString();
      }
      return '0';
    },
    chatUserHeight() {
      if (this.status === '5' && this.commonData.isComplainUser.toString() === '1') {
        return this.chatHeight - 50 - 86 - 60;
      }
      return this.chatHeight - 86 - 60;
    },
    chatServerHeight() {
      return this.chatHeight - 50 - 60 - 6;
    },
    userSide() {
      let from = '';
      let to = '';
      if (this.commonData.side === 'BUY') {
        from = this.commonData.buyer.uid.toString();
        to = this.commonData.seller.uid.toString();
      } else if (this.commonData.side === 'SELL') {
        from = this.commonData.seller.uid.toString();
        to = this.commonData.buyer.uid.toString();
      }
      return {
        from,
        to,
      };
    },
  },
  beforeDestroy() {
    this.beforeDestroyMethods();
  },
  methods: {
    beforeDestroyMethods() {
      // 如果 商家聊天 ws已经创建好了，则给他断开
      this.tab = '';
      if (this.userWsReady) {
        this.userWs.close();
      }
      this.userWs = null;
      clearInterval(this.serverTimer);
      clearTimeout(this.sendTimer);
      clearTimeout(this.resetTimer);
    },
    goUid(id) {
      if (id) {
        this.$router.push(`/stranger?uid=${id}`);
      }
    },
    userInpKeyup(e) {
      if (e.keyCode === 13) {
        this.$bus.$emit('button-click', 'userButton');
      }
    },
    serverInpKeyup(e) {
      if (e.keyCode === 13) {
        this.$bus.$emit('button-click', 'serverButton');
      }
    },
    userBtnClick() {
      if (this.userWsReady) {
        this.userBtnLoading = true;
        this.sendTimer = setTimeout(() => {
          if (this.userBtnLoading) {
            this.userBtnLoading = false;
            if (this.userWs && this.userWsReady) {
              this.userWs.close();
              this.userInp = '';
            }
          }
        }, 5000);
        this.userTime = new Date().getTime();
        this.userWs.send(
          JSON.stringify({
            chatId: this.chatId,
            message: {
              content: this.userInp,
              from: this.userSide.from,
              to: this.userSide.to, // 接收人,如果没有则置空,如果有多个接收人则用,分隔
              orderId: this.commonData.sequence,
              time: this.userTime,
            },
            type: 'message',
          }),
        );
      }
    },
    getUserData() {
      this.axios({
        url: 'chatMsg/message',
        method: 'post',
        params: {
          fromId: this.userSide.from,
          toId: this.userSide.to,
          orderId: this.commonData.sequence,
        },
        hostType: 'otc',
      }).then((data) => {
        if (data.code.toString() === '0') {
          const arr = [];
          data.data.forEach((v) => {
            let obj = {};
            if (this.commonData.side === 'BUY') {
              obj = v.fromId === this.userSide.from ? this.commonData.buyer : this.commonData.seller;
            } else {
              obj = v.fromId === this.userSide.from ? this.commonData.seller : this.commonData.buyer;
            }
            arr.push({
              replayContent: v.content, // 追 问内容
              contentType: '1', // 1-文字内容 2-图片url
              userType: v.fromId === this.userSide.from ? '2' : '1', // 用户类型：1-后台用户 2-前端用户
              ctime: v.ctime, // 提交时间
              obj,
            });
          });
          this.userData = arr;
          this.$nextTick(() => {
            this.$refs.userMessage.scrollTo(
              {
                y: '100%',
              },
              false,
            );
          });
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
    // 创建商家聊天 / 创建ws
    initUser() {
      if (this.tab !== 'user') {
        return;
      }
      this.getUserData(); // 获取历史数据
      // 创建ws
      if (this.otcWsUrl.length) {
        this.userWs = null; // 重置
        this.wsTime = new Date().getTime(); // 记录下创建时间 用于避免高频率创建
        const str = this.userSide.from + this.userSide.to; // 自己的id + 对方的id
        // 开始创建
        this.userWs = new WebSocket(`${getChatWsUrl()}/${window.btoa(str)}`);
        // 已经创建
        this.userWs.onopen = () => {
          if (this.tab !== 'user') {
            return;
          }
          this.userWsReady = true;
        };
        // 接收数据
        this.userWs.onmessage = (ev) => {
          if (this.tab !== 'user') {
            return;
          }
          if (ev.data) {
            const data = JSON.parse(ev.data);
            this.chatId = data.chatId;
            if (data.message) {
              if (Number(data.message.time) === Number(this.userTime)) {
                this.userBtnLoading = false;
                this.userInp = '';
              }
              let obj = {};
              if (this.commonData.side === 'BUY') {
                obj = data.message.from === this.userSide.from
                  ? this.commonData.buyer
                  : this.commonData.seller;
              } else {
                obj = data.message.from === this.userSide.from
                  ? this.commonData.seller
                  : this.commonData.buyer;
              }
              this.userData.push({
                replayContent: data.message.content, // 追 问内容
                contentType: '1', // 1-文字内容 2-图片url
                userType: data.message.from === this.userSide.from ? '2' : '1', // 用户类型：1-后台用户 2-前端用户
                ctime: data.message.time, // 提交时间
                obj,
              });
              this.$nextTick(() => {
                this.$refs.userMessage.scrollTo(
                  {
                    y: '100%',
                  },
                  false,
                );
              });
            }
          }
        };
        // 一旦发现错误就关闭
        this.userWs.onerror = () => {
          if (this.tab !== 'user') {
            return;
          }
          this.userWs.close();
        };
        // 错误处理
        this.userWs.onclose = () => {
          if (this.tab !== 'user') {
            return;
          }
          this.userWsReady = false;
          const nowTime = new Date().getTime();
          const spk = nowTime - this.wsTime;
          // 避免高频率创建
          if (spk > 3000) {
            this.initUser();
          } else {
            // 如果切到客服 或者退出 这个倒计时就没有必要继续了
            this.resetTimer = setTimeout(() => {
              clearTimeout(this.resetTimer);
              this.initUser();
            }, 3000 - spk);
          }
        };
      }
    },
    serverBtnClick() {
      this.serverBtnLoading = true;
      this.axios({
        url: 'question/reply_create',
        method: 'post',
        params: {
          rqId: this.commonData.complainId,
          rqReplyContent: this.serverInp,
          contentType: '1',
        },
      }).then((data) => {
        this.serverBtnLoading = false;
        if (data.code.toString() === '0') {
          this.serverScroll = true;
          this.getServerData();
          this.serverInp = '';
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
    setTab(v) {
      this.tab = v;
    },
    getServerData() {
      clearInterval(this.serverTimer);
      this.axiosServer();
      this.serverTimer = setInterval(() => {
        this.axiosServer(true);
      }, 3000);
    },
    axiosServer(auto) {
      const headers = {};
      if (auto) {
        headers['exchange-auto'] = '1';
      }
      this.axios({
        url: 'question/details_problem',
        headers,
        params: {
          id: this.commonData.complainId,
        },
      }).then((data) => {
        if (data.code.toString() === '0') {
          const arr = [];
          if (data.data.rqInfo) {
            arr.push({
              replayContent: data.data.rqInfo.rqDescribe, // 追 问内容
              contentType: '1', // 1-文字内容 2-图片url
              userType: '2', // 用户类型：1-后台用户 2-前端用户
              ctime: data.data.rqInfo.ctime, // 提交时间
            });
          }
          this.serverData = [...arr, ...data.data.rqReplyList];
          this.addServeData(this.serverData);
          this.errorServeData(this.serverData);
          this.$nextTick(() => {
            if (this.serverScroll) {
              this.serverScroll = false;
              this.$refs.serverMessage.scrollTo(
                {
                  y: '100%',
                },
                false,
              );
            }
          });
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
    // 上传图片
    fileChange(e) {
      const fileSize = e.srcElement.files[0].size / 1024 / 1024;
      if (fileSize <= 2) {
        const from = new FormData();
        from.append('file', this.$refs.fileInp.files[0], this.$refs.fileInp.files[0].name);
        // if (this.$store.state.baseData.publicInfo.uploadFlag === '1') {
        //   ajaxUrl = window.HOST_API.updata_url
        //   hostType = 'upload'
        // }
        this.axios({
          url: 'common/upload_img',
          headers: { 'Content-Type': 'multipart/form-data' },
          params: from,
          method: 'post',
        }).then((data) => {
          if (data.code === '0') {
            this.axios({
              url: 'question/reply_create',
              method: 'post',
              params: {
                rqId: this.commonData.complainId,
                rqReplyContent: data.data.filename,
                contentType: '2',
              },
            }).then((cdata) => {
              if (cdata.code.toString() === '0') {
                this.serverScroll = true;
                this.getServerData();
              } else {
                this.$bus.$emit('tip', { text: cdata.msg, type: 'error' });
              }
            });
          } else {
            this.$bus.$emit('tip', { text: data.msg, type: 'error' });
          }
        });
      } else {
        this.$bus.$emit('tip', { text: '请上传2MB以内的图片', type: 'warning' });
      }
    },
    getvideo(e, index, ctime) {
      let files = e.target.files[0];
      let from = new FormData();
      let nowDate = ctime || Date.now();
      if (files.size > 200 * 1024 * 1024) {
        this.$bus.$emit('tip', { text: '请上传200MB以内的视频', type: 'warning' });
        return;
      }
      from.append('file', this.$refs.videoInp.files[0], this.$refs.videoInp.files[0].name);
      // 本地视频展示
      const link = this.getObjectURL(files); //获取本地视频的地址在页面显示
      this.video = link;
      if (!index) {
        this.videoLoading = true;
        this.addServeData(this.serverData, nowDate);
        this.videoEvent.push({
          e,
          index: this.serverData.length - 1,
          ctime: nowDate
        });
      } else {
        this.serverData[index].loading = true;
        this.serverData[index].error = false;
        this.serverData = JSON.parse(JSON.stringify(this.serverData));
      }
      // 上传视频请求
      this.axios({
        url: 'common/upload_video',
        headers: { 'Content-Type': 'multipart/form-data' },
        params: from,
        method: 'post',
      }).then((data) => {
        if (data.code === '0') {
          this.axios({
            url: 'question/reply_create',
            method: 'post',
            params: {
              rqId: this.commonData.complainId,
              rqReplyContent: data.data.filename,
              contentType: '3',
            },
          }).then((cdata) => {
            if (cdata.code.toString() === '0') {
              this.serverScroll = true;
              this.videoLoading = false;
              this.videoError = false;
              this.getServerData();
              e.target.value = '';
            } else {
              this.$bus.$emit('tip', { text: cdata.msg, type: 'error' });
              this.errorHandle(this.serverData, nowDate);
            }
          })
          .catch(() => {
            this.errorHandle(this.serverData, nowDate);
          });
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
          this.errorHandle(this.serverData, nowDate);
        }
      })
      .catch(() => {
        this.errorHandle(this.serverData, nowDate);
      });
    },
    getObjectURL(file) {
      var url = null;
      // 针对不同的浏览器执行不同的 js 函数
      if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      }
      return url;
    },
    addServeData(data, date) {
      if (this.videoLoading) {
        this.serverData = data;
        this.serverScroll = true;
        const obj = {
          replayContent: this.video,
          contentType: '3',
          userType: '2',
          ctime: date, //moment().utcOffset(8),
          loading: true,
        }
        this.serverData = [...this.serverData, obj];
        this.sortServeData();
      }
    },
    errorServeData(data, date) {
      if (this.videoError) {
        this.serverData = data;
        this.serverScroll = true;
        const obj = {
          replayContent: this.video,
          contentType: '3',
          userType: '2',
          ctime: date, //moment().utcOffset(8),
          error: true,
        }
        this.serverData = [...this.serverData, obj];
        this.sortServeData();
      }
    },
    errorHandle(data, date) {
      this.videoLoading = false;
      this.videoError = true;
      let delIndex;
      data.forEach((cEle, cIndex) => {
        if (date === cEle.ctime) {
          delIndex = cIndex
        }
      })
      data.splice(delIndex, 1);
      this.errorServeData(data, date);
    },
    retryVideo(index) {
      const currentItem = this.videoEvent.filter((item) => item.index === index)
      this.getvideo(currentItem[0].e, currentItem[0].index, currentItem[0].ctime);
    },
    sortServeData() {
      this.serverData = this.serverData.sort((a,b) => {
        return a.ctime - b.ctime
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.otcDeatilOrder-chat {
  width: 320px;
  position: absolute;
  right: 0;
  top: 0;
  .buttonClass {
    font-size: 12px;
  }
  .chat-title {
    height: 50px;
    padding-left: 26px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    box-sizing: border-box;
    li {
      float: left;
      line-height: 56px;
      margin-right: 40px;
      cursor: pointer;
      font-size: 14px;
      user-select: none;
      position: relative;
    }
    span {
      position: absolute;
      width: 40px;
      height: 2px;
      bottom: 6px;
      left: 50%;
      display: inline-block;
      transform: translateX(-50%);
    }
  }
  .chat-user {
    .textInput {
      width: 200px;
    }
    .chat-user-title {
      height: 86px;
      width: 100%;
      box-sizing: border-box;
      padding: 18px 20px;
      .user-page {
        cursor: pointer;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        display: inline-block;
        vertical-align: middle;
        float: left;
        overflow: hidden;
        text-align: center;
        line-height: 50px;
        font-size: 22px;
        img {
          width: 50px;
          height: 50px;
        }
      }
      .user-mess {
        margin-top: 6px;
        float: left;
        margin-left: 10px;
        display: inline-block;
        vertical-align: middle;
      }
      .user-text {
        margin-top: 6px;
        display: inline-block;
        vertical-align: middle;
        float: right;
        text-align: end;
      }
      .user-name {
        font-size: 14px;
      }
      .user-status {
        margin-top: 10px;
        font-size: 12px;
      }
    }
    .chat-user-message {
      // overflow-y: scroll;
      width: 100%;
    }
    .chat-user-message ul {
      width: 100%;
      padding: 20px;
      box-sizing: border-box;
    }
  }
  .chat-server {
    .textInput {
      width: 200px;
    }
    .chat-server-message {
      overflow-y: scroll;
      width: 100%;
    }
    .chat-server-message ul {
      width: 100%;
      padding: 20px;
      box-sizing: border-box;
    }
    .chat-server-first {
      margin: 20px 0;
      font-size: 12px;
    }
  }
  .chat-send {
    height: 60px;
    padding: 0 20px;
    position: relative;
    .textInput {
      margin-top: 15px;
      height: 30px;
      line-height: 30px;
      font-size: 14px;
      margin-right: 10px;
    }
    .sendButton {
      position: absolute;
      right: 20px;
      top: 15px;
      .sendButton-img {
        vertical-align: middle;
        display: inline-block;
        position: relative;
        cursor: pointer;
        margin-right: 10px;
        .files {
          width: 30px;
          height: 30px;
          cursor: pointer !important;
          display: inline-block;
          position: absolute;
          opacity: 0;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          z-index: 3;
        }
      }
      .sendButton-bg {
        width: 30px;
        height: 30px;
        background: rgba(23, 82, 252, 0.2);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        border-radius: 30px;
      }
    }
  }
  .chat-item {
    margin-bottom: 20px;
    .chat-page {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      text-align: center;
      line-height: 30px;
      font-size: 12px;
      overflow: hidden;
      img {
        width: 30px;
        height: 30px;
      }
    }
    .chat-message-text {
      min-height: 12px;
      padding: 8px 10px;
      font-size: 12px;
      border-radius: 2px;
      max-width: 220px;
      line-height: 20px;
      word-wrap: break-word;
      display: inline-block;
    }
    .chat-message-img, .chat-message-video {
      padding: 8px 10px;
      max-width: 220px;
      border-radius: 2px;
      img, video {
        max-width: 220px;
        max-height: 300px;
        display: block;
      }
    }
    .chat-message-video {
      padding: 0;
      position: relative;
      .chat-message-video-icons {
        position: absolute;
        bottom: 0;
        left: -24px;
      }
    }
    .chat-message-time {
      font-size: 12px;
      margin-top: 4px;
    }
  }
  .chat-left {
    .chat-page,
    .chat-message {
      float: left;
    }
    .chat-message {
      margin-left: 10px;
    }
    .chat-message-text,
    .chat-message-img {
      float: left;
    }
  }
  .chat-right {
    .chat-page,
    .chat-message {
      float: right;
    }
    .chat-message {
      margin-right: 10px;
    }
    .chat-message-time {
      text-align: end;
    }
    .chat-message-text,
    .chat-message-img {
      float: right;
    }
  }
  input::-webkit-input-placeholder {
    font-size: 12px;
    line-height: 30px;
  }
  input::-moz-placeholder {
    font-size: 12px;
    line-height: 30px;
  }
  input::-moz-placeholder {
    font-size: 12px;
    line-height: 30px;
  }
  input::-ms-input-placeholder {
    font-size: 12px;
    line-height: 30px;
  }
}


.upimg {
  width: 3rem;
  height: 3rem;
  border: 1px dotted #ccc;
  margin-bottom: 0.05rem;
  overflow: hidden;
  position: relative;
  .del{
    position: absolute;
    right: -0.1rem;
    top: -0.1rem;
    width: 0.5rem;
    height: 0.5rem;
    background: pink;
    z-index: 1;
  }

  img,
  video {
    width: auto;
    height: 3rem;
    position: absolute;
    display: block;
    top: 0;
  }

  input {
    display: block;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 10000;
  }
}
input[type="file"]::-webkit-file-upload-button {
  width:30px;
  height: 30px;
  cursor: pointer;
}
</style>
